import type { ReferenceDataField } from '@moment/trading-types/instrument-data'

import tradeBlotterColumnDefinitions from '@/components/molecules/trade-blotter/columns'
import {
  OrderStatusGroup,
  type TradeBlotterColumnId,
} from '@/types/enums/trade-blotter'
import {
  type ColumnState,
  QuickPreviewLocation,
  RowClickBehavior,
  type TradeBlotterConfig,
  ViewType,
} from '@/types/schema/page-configs/trade-blotter'
import {
  getInstrumentDataFieldFormatter,
  type MarketDataField,
} from '@/utils/presentation/instrument-data-transforms'

// TODO - Adding TradeBlotter default config in next PR
export const defaultTradeBlotterConfig: TradeBlotterConfig = {
  columnState: {
    [OrderStatusGroup.All]: getDefaultColumnStateForTab(OrderStatusGroup.All),
    [OrderStatusGroup.Active]: getDefaultColumnStateForTab(
      OrderStatusGroup.Active,
    ),
    [OrderStatusGroup.Completed]: getDefaultColumnStateForTab(
      OrderStatusGroup.Completed,
    ),
  },
  rowClickBehavior: RowClickBehavior.Preview,
  quickPreviewLocation: QuickPreviewLocation.Right,
  viewType: ViewType.Standard,
}

export function getDefaultColumnStateForTab(
  _tab: OrderStatusGroup,
): ColumnState[] {
  return Array.from(tradeBlotterColumnDefinitions.entries()).map(
    ([colId, columnDef]) => {
      const field = colId as ReferenceDataField | MarketDataField
      const formatter = getInstrumentDataFieldFormatter(field)
      const formattedName = formatter(field)
      return {
        colId: colId as TradeBlotterColumnId,
        displayName: formattedName,
        visible: !columnDef.hide,
      }
    },
  )
}
